import React, {useState} from 'react'
import {FormattedMessage} from 'react-intl'
import {signUp} from 'aws-amplify/auth'
import Typography from '@material-ui/core/Typography'
import Layout from 'components/layouts/WelcomePageLayout'
import {SignUpForm, SignUpConfirmationForm} from 'components/organisms/signup'

function SignUpPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [newUser, setNewUser] = useState(null)

  const handleSubmit = async ({email, password}) => {
    setEmail(email)
    setPassword(password)
    try {
      const result = await signUp({
        username: email,
        password,
        options: {
          userAttributes: {
            email,
          },
        },
      })
      setNewUser(result)
    } catch (e) {
      // https://serverless-stack.com/chapters/signup-with-aws-cognito.html
      // 1. Check for the UsernameExistsException in the handleSubmit method’s catch block.
      // 2. Use the Auth.resendSignUp() method to resend the code if the user has not been previously confirmed.
      //    Here is a link to the Amplify API docs.
      // 3. Confirm the code just as we did before.
      alert(e.message)
    }
  }

  return (
    <Layout header={Header}>
      {newUser === null ? (
        <SignUpForm onSubmit={handleSubmit} />
      ) : (
        <SignUpConfirmationForm
          email={email}
          password={password}
        />
      )}
    </Layout>
  )
}

const Header = ({className}) => (
  <Typography variant="h5" component="h1" className={className}>
    <FormattedMessage id="signUp.greeting" />
  </Typography>
)

export default SignUpPage
